const mutations = {
  SET_EXPENSES(state, payload) {
    const expenseRatioGross = payload.expenses && payload.expenses.ExpenseRatioGross;
    const expenseRatioNet = payload.expenses && payload.expenses.ExpenseRatioNet;

    state.expensesData = {
      expenseRatioGross,
      expenseRatioNet
    };
  }
};

const getters = {
  expensesData: state => state.expensesData
};

const state = {
  expensesData: null
};


export default {
  state,
  getters,
  mutations
};
